import moment from 'moment';
import { FormStatus } from '../../../FormStatus';
import { ICON_VARIANT_TYPE, Icons } from 'pages/Workshop/Forms/Icons';
import styles from './styles.module.scss';
import { Fragment, useState } from 'react';
import { MegaPhoneModal } from '../MegaPhoneModal';

export const FormDetailHeader = (props) => {
  const {
    formDetails,
    isDraftForm,
    selectedFormStatus,
    isFormCreator,
    showMegaPhone,
    handleSendMessage,
    onClose,
  } = props;

  const [showMegaPhoneModal, setShowMegaPhoneModal] = useState(false);

  const openMegaPhoneModal = () => {
    setShowMegaPhoneModal(true);
  };

  const closeMegaPhoneModal = () => {
    setShowMegaPhoneModal(false);
  };

  const getTitle = () => {
    let title = 'Sent: ';
    if (formDetails) {
      const { isCompleted, isVoid } = formDetails;

      title = isCompleted
        ? 'Completed: '
        : isVoid
        ? 'Voided: '
        : isDraftForm
        ? 'Last Edited: '
        : title;
    }

    return title;
  };
  return (
    <Fragment>
      <div className={styles.formDocumentHeader}>
        <p className={styles.formName}>{formDetails?.formName}</p>
        <p className={styles.formSent}>
          {getTitle()}
          {moment(formDetails?.formDocument?.date).format('MM/DD/YYYY [at] hh:mm A')}
        </p>

        <FormStatus selectedFormStatus={selectedFormStatus} />

        <div className={styles.headerIcons}>
          {isFormCreator && showMegaPhone && (
            <div className={styles.megaPhoneIcon}>
              <Icons variant={ICON_VARIANT_TYPE.MEGAPHONE} onClick={() => openMegaPhoneModal()} />
            </div>
          )}

          <Icons variant={ICON_VARIANT_TYPE.MODAL_CLOSE} onClick={onClose} />
        </div>
      </div>

      {showMegaPhoneModal && (
        <MegaPhoneModal
          signatories={formDetails?.signatories}
          editors={formDetails?.editors}
          handleSendMessage={handleSendMessage}
          setShowMegaPhoneModal={setShowMegaPhoneModal}
          onCloseModal={closeMegaPhoneModal}
          hideEditorPanel={true}
        />
      )}
    </Fragment>
  );
};
